module.exports = __webpack_public_path__ + "img/visual_bg.e8ad288b.jpg";